module.exports = __webpack_public_path__ + "img/voice_2.1d27c1d3.svg";